import { useEffect, useState } from "react";
import { Download, Users } from "lucide-react";
import { api, inr } from "@/lib/api";

export const ReportsTab = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/reports/customers").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  const downloadCsv = () => {
    const header = "Name,Email,Mobile,City,Orders,Total Spent\n";
    const body = rows.map((r) => [r.name, r.email, r.phone, r.city, r.orders, r.spent].map((v) => `"${String(v).replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([header + body], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "vira-customers-report.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!rows) return <p className="text-gray-400 text-sm py-12">Building report…</p>;

  return (
    <div className="flex flex-col gap-4" data-testid="reports-tab">
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500 flex items-center gap-2"><Users size={15} className="text-[#E80071]" /> Customer report — built from every order</p>
        <button onClick={downloadCsv} disabled={!rows.length} data-testid="reports-download-btn" className="flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm disabled:opacity-50">
          <Download size={14} /> Download CSV
        </button>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-x-auto">
        <table className="w-full text-left border-collapse min-w-[720px]">
          <thead>
            <tr>
              {["Name", "Email", "Mobile", "City", "Orders", "Total spent"].map((h) => (
                <th key={h} className="bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wider py-3 px-4 border-b border-gray-200">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={6} className="py-14 text-center text-gray-400 text-sm" data-testid="reports-empty">No customers yet.</td></tr>
            ) : (
              rows.map((r, i) => (
                <tr key={i} className="hover:bg-gray-50 transition-colors" data-testid={`report-row-${i}`}>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-900 font-medium">{r.name}</td>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-600">{r.email || "—"}</td>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-600">{r.phone || "—"}</td>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-600">{r.city || "—"}</td>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-600">{r.orders}</td>
                  <td className="py-3 px-4 border-b border-gray-100 text-gray-900 font-medium">{inr(r.spent)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
